import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ACLS = "fetchAcls";
export const SYNC_ACLS = "syncAcls";

// mutation types
export const SET_MQTT_USERS = "setMqttUsers";

const state = {
  mqttUsers: []
};

const getters = {
  mqttUsers(state) {
    return state.mqttUsers;
  }
};

const actions = {
  [FETCH_ACLS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("acls")
        .then(({ data }) => {
          context.commit(SET_MQTT_USERS, data.data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [SYNC_ACLS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`acls/sync`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_MQTT_USERS](state, users) {
    state.mqttUsers = users;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
